
import React, { useState, useEffect } from 'react';
import TableData from './TableData';
import useAuth from '../hooks/useAuth.js';
import 'sweetalert2/dist/sweetalert2.css';
import axiosInstance from '../utilities/axiosInstance';
import "../styles/profileDetails.scss"
import { Listbox } from '@headlessui/react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { showAlert } from "./AlertPopup";
import ManagerProfileTable from "./ManagerProfileTable.js"

const Manager = () => {
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [managerName, setManagerName] = useState([]);
  const [managerData, setManagerData] = useState([]);
  const { auth } = useAuth();

  const handleChange = (value) => {
    console.log("selectedProject", selectedProject)
    setSelectedProject(value);
    handleProjectChange({ target: { name: 'assignedTo', value } }); // mimic native event
  };


  const getProject = () => {
    if (auth.profile_role !== 1) {
      axiosInstance
        .get(`/projectlist`)
        .then((response) => {
          const allProject = response.data;
          axiosInstance
            .get(`/allprofiles?profileId=${auth.profileId}`)
            .then((response) => {
              const managerProfiles = response.data.filter((item) => item.profile_role === 2 && item.profile_id === auth.profile_id);
              const managerProjectIds = managerProfiles.flatMap((item) => item.project_id.split(","));
              const filteredArray = allProject.filter((item1) =>
                managerProjectIds.includes(item1.project_id.toString())
              );
              setProjectList(filteredArray);
            })
            .catch((error) => console.error(error));
        })
        .catch((error) => console.error(error));
    } else {
      axiosInstance
        .get(`/projectlist`)
        .then((response) => {
          const allProject = response.data;
          setProjectList(allProject);
        })
        .catch((error) => console.error(error));
    }
  };

  const getAllManager = () => {
    axiosInstance
      .get(`/listoworker?role_id=2`)
      .then(response => {
        setManagerData(response.data)
      })
      .catch(error => console.error(error));
  }
  
  const getManagerName = (projectId) => {
    axiosInstance
      .get(`/managername/${projectId}`)
      .then((response) => {
        const manager = response.data.manager_names;
        setManagerName(manager.join(', '));
      })
      .catch((error) => {
        showAlert(error.response.data.message, 'error');
        setManagerName("");
      });
  };

  function handleManagerList(){
    setSelectedProject(null)
  }
  
  useEffect(() => {
    getProject();
    getAllManager();
  }, []);

  const handleProjectChange = (event) => {
    const selectedProjectId = event.target.value;
    setSelectedProject(selectedProjectId);
    if (selectedProjectId) {
      getManagerName(selectedProjectId);
    } else {
      setManagerName('');
    }
  };

  return (
    <div>
      <div className="border-b border-gray-d-200 dark:border-white flex justify-between items-center pb-3">
        <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main dark:text-white">
          Welcome {auth.profile_username === "admin" ? auth.profile_username : auth.profile_username}
        </h2>
        {selectedProject && 
        <button
          type="primary"
          onClick={handleManagerList}
          // disabled={!hasSelected || !assignedTo}
          className="w-[200px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
        >
          Back to manager list
        </button>
        }
      </div>
      <div>
        <div className="max-w-[650px] mx-auto mt-11">
          <label className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">Assigned to Project</label>
          <div className="relative font-poppins text-[15px] mt-[5px] mb-[20px]">
            <Listbox value={selectedProject} onChange={handleChange}>
              <div className="relative">
                <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color text-gray-main">
                  <span className="block truncate">
                    {selectedProject
                      ? projectList.find(p => p.project_id === selectedProject)?.project_name
                      : "Select"}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                    <FaChevronDown className="h-3 w-3 text-gray-400" />
                  </span>
                </Listbox.Button>

                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  {projectList.map((project) => (
                    <Listbox.Option key={project.project_id} value={project.project_id}>
                      {({ active }) => (
                        <div
                          className={clsx(
                            "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center border-b border-[#28325A26]",
                            {
                              "text-deep-blue border-deep-blue": active,
                              "text-gray-900": !active,
                            }
                          )}
                        >
                          <span>{project.project_name}</span>
                          {(selectedProject === project.project_id || active) && (
                            <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                              <FaCheck className="text-white text-[10px]" />
                            </span>
                          )}
                        </div>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </div>
            </Listbox>
          </div>
        </div>
        {auth.profile_role !== 2 && (
          <div className="text-gray-main pb-5 ml-2 dark:text-white">
            {managerName && selectedProject && (
              <p className="font-normal text-base text-center">
                <span className="font-semibold">Manager Name: </span>
                {managerName}
              </p>
            )}
          </div>  
        )}
        {selectedProject 
          ? <div className="ant-table-wrapper details-view-table" ><TableData selectedProject={selectedProject} /></div>
          : <div className="ant-table-wrapper details-view-table" ><ManagerProfileTable data={managerData} /></div>
        }
      </div>
    </div>
  );
};

export default Manager;

